import { CBLanguageService, LanguageValues } from "cbcore-ts"
import { RHNavbar } from "./Custom components/RH/Utils_slop/RHDesignTokens"


export class LanguageService extends CBLanguageService {
    
    static override languageValues: LanguageValues = {
        
        en: {
            
            languageName: "English",
            languageNameShort: "ENG",
            
            // topBarTitle: "Riigihangete registri statistika (Beta)",
            // topBarTitle: "Hangete Register",   // tavaline tekst; nüüd faux-small-caps HTML (algustähed span.rhLogoInitial, 1.4×)
            topBarTitle: '<span class="rhLogoInitial">H</span>angete <span class="rhLogoInitial">R</span>egister',

            selectLanguageTitle: "Select language",
            leftBarTitle: "Title",
            CBTableViewSearch: "Search",
            
            numberOfProcurementsStarted: "Avaldatud hankeid",
            numberOfProcurementLots: "Hankeosi",
            averageNumberOfOffersPerProcurementLotNotice: "Keskmine pakkumuste arv hankeosa kohta",
            numberOfProcurementLotsWithNoOffers: "Pakkumusteta hankeosi",
            numberOfContractsForTheYear: "Sõlmitud lepinguid",
            contractMonetarySum: "Lepingute kogumaht",
            numberOfContractsWithOneOffer: "Lepinguid 1 pakkumusega hankeosades",
            numberOfContractsWithTwoOffers: "Lepinguid 2 pakkumusega hankeosades",
            numberOfContractsWithAtLeastThreeOffers: "Lepinguid vähemalt 3 pakkumusega hankeosades",
            averageNumberOfOffersPerContract: "Keskmine pakkumuste arv lepingu kohta",
            numberOfUnannouncedProcurementContractOverviews: "Väljakuulutamiseta läbirääkimistega hankemenetlusi",
            averageLengthOfProcurementBeforeContractSigningInDays: "Keskmine menetluse kestus (päevades)",

            topBarActingAsCompany: "Acting as: %COMPANY_NAME%",
            // %MANAGING_COMPANY_NAME% is the company actually administering %COMPANY_NAME%.
            topBarActingAsManagedCompany: "Acting as: %COMPANY_NAME% (managed by %MANAGING_COMPANY_NAME%)",
            topBarActingAsAllCompanies: "Acting as: all companies"


        },
        est: {
            
            languageName: "Eesti keel",
            languageNameShort: "EST",
            
            // topBarTitle: "Riigihangete registri statistika (Beta)",
            // topBarTitle: "Hangete Register",   // tavaline tekst; nüüd faux-small-caps HTML (algustähed span.rhLogoInitial, 1.4×)
            topBarTitle: '<span class="rhLogoInitial">H</span>angete <span class="rhLogoInitial">R</span>egister',
            RHRStatisticsViewControllerTitle_offerer: "Riigihangete registri statistika – lepingupartnerid",
            RHRStatisticsViewControllerTitle_procurer: "Riigihangete registri statistika – hankija",
            
            RHRStatisticsComparisonViewControllerTitle_offerer: "Riigihangete registri statistika – lepingupartnerite võrdlus",
            RHRStatisticsComparisonViewControllerTitle_procurer: "Riigihangete registri statistika – hankijate võrdlus",
            
            selectLanguageTitle: "Vali keel",
            leftBarTitle: "Pealkiri",
            CBTableViewSearch: "Otsi",
            
            procurerName: "Hankija",
            offerersDataWithCount: "Lepingupartnerid (tk)",
            offerersDataWithMonetarySum: "Lepingupartnerid (€)",
            averageNumberOfOffersPerProcurementLotNotice: "Keskmine pakkumuste arv hankeosa kohta",
            numberOfProcurementLotsWithNoOffers: "Pakkumusteta hankeosi",
            numberOfContractsWithOneOffer: "Lepinguid 1 pakkumusega hankeosades",
            numberOfContractsWithTwoOffers: "Lepinguid 2 pakkumusega hankeosades",
            numberOfContractsWithAtLeastThreeOffers: "Lepinguid vähemalt 3 pakkumusega hankeosades",
            averageNumberOfOffersPerContract: "Keskmine pakkumuste arv lepingu kohta",
            numberOfUnannouncedProcurementContractOverviews: "Väljakuulutamiseta läbirääkimistega hankemenetlusi",
            averageLengthOfProcurementBeforeContractSigningInDays: "Keskmine menetluse kestus (päevades)",

//Hankija võrdlus:
            searchableDropdownNotSelected: "valik tegemata",
            numberOfContractsForTheYear: "Sõlmitud lepinguid",
            contractMonetarySum: "Lepingute kogumaht",
            numberOfProcurementsStarted: "Alustatud hankeid",
            numberOfProcurementLots: "Hankeosi",
            numberOfProcurementLotsWithAtleastThreeOffers: "Vähemalt 3 pakkumusega hankeosi",


//Pakkuja andmed: (2 esimest välja ei kuva andmeid)
            offererName: "Lepingupartner",
            procurersDataWithCount: "Hankijad (tk)",
            procurersDataWithMonetarySum: "Hankijad (€)",
            // numberOfContractsForTheYear: "Sõlmitud lepinguid",
            // contractMonetarySum: "Lepingute kogumaht",
            numberOfContractsWonForTheYear: "Sõlmitud lepinguid",
//          NB! võiks lisada ka selle dumpingu indeksi
//          Keskmine pakkumuste arv lepingu kohta - MAHA        
//          numberOfContractsWonWithOneOffer - MAHA
//          numberOfContractsWonWithTwoOffers - MAHA
//          numberOfContractsWonWithAtLeastThreeOffers - MAHA
            numberOfUnannouncedProcurementContractOverviewsWonByOfferer: "Väljakuulutamiseta läbirääkimistega hankemenetlusi",
//          Keskmine menetluse kestus (päevades) - MAHA


//Pakkuja võrdlus:



            topBarActingAsCompany: "Tegutseb: %COMPANY_NAME%",
            // %MANAGING_COMPANY_NAME% on ettevõte, kes %COMPANY_NAME% nimel tegelikult haldab.
            topBarActingAsManagedCompany: "Tegutseb: %COMPANY_NAME% (haldajaks %MANAGING_COMPANY_NAME%)",
            topBarActingAsAllCompanies: "Tegutseb: Kõik ettevõtted",

            bottomBarContent: "<!— ⬇️ Footer algus -->\n" +
                "                <footer class=\"site-footer\">\n" +
                "            Küsimuste ja ettepanekute korral kirjuta aadressil&nbsp;\n" +
                "                <a href=\"mailto:info@rhr.ee\">info@rhr.ee</a>.\n" +
                "            %UPDATE_TIME_STRING%" +
                "                </footer>\n" +
                "                \n" +
                "                <style>\n" +
                "            .site-footer {\n" +
                // "    background: #f5f5f7;\n" +
                "    background: " + RHNavbar.bottomBarContentBackgroundColor.stringValue + ";\n" +
                // "    color: #4b4b4b;\n" +
                "    color: " + RHNavbar.bottomBarTextColor.stringValue + ";\n" +
                "    padding: 1rem;\n" +
                "    font-size: 0.9rem;\n" +
                "    font-family: " + RHNavbar.bottomBarFontFamily + ";\n" +
                "    height: 100%; \n" +
                "    text-align: center;\n" +
                "}\n" +
                "\n" +
                ".site-footer a {\n" +
                // "    color: #0068c4;\n" +
                "    color: " + RHNavbar.bottomBarLinkColor.stringValue + ";\n" +
                // "    text-decoration: none;\n    " +
                "    text-decoration: underline;\n    " +
                "}\n" +
                "\n" +
                ".site-footer a:hover {\n" +
                // "    text-decoration: underline;\n" +
                "    color: " + RHNavbar.bottomBarLinkHoverColor.stringValue + ";\n" +
                "}\n" +
                "</style>\n" +
                "<!-- ⬆️ Footer lõpp -->\n"
            
            
        }
        
        
    }
    
    
}


// CBLanguageService.currentClassObject = LanguageService
// LanguageService.useStoredLanguageValues({})
// UICore.languageService = LanguageService
























